import crypto from 'crypto';
import { base62Encoder } from './baseXEncoder';

const algorithm = 'aes-192-cfb';
const key = 'rqRSGXKmy8yydRJWwk5LmKp7' // crypto.randomBytes(24);
export const generateIV = (id) => {
    let tempID = `${id}`;

    // string nya harus sepanjang 16 karakter. isinya adalah hasil append antara 0 dengan meeting id
    while(tempID.length < 16) {
        tempID = `0${tempID}`; 
    }

    return Buffer.from(tempID, "ascii");
}

export const encrypt = (text, iv) => {
  const cipher = crypto.createCipheriv(algorithm, Buffer.from(key), iv);
  let encrypted = cipher.update(`${text}`);
  encrypted = Buffer.concat([encrypted, cipher.final()]);
  
  return base62Encoder.encode(encrypted);
}

export const decrypt = (text, iv) => {
  const encryptedText = base62Encoder.decode(text);
  const decipher = crypto.createDecipheriv(algorithm, Buffer.from(key), iv);
  let decrypted = decipher.update(encryptedText);
  decrypted = Buffer.concat([decrypted, decipher.final()]);
  return decrypted.toString();
}